<template>
    <div class="lms__user_account_logactivity">
        <div class="lms__user_account_logactivity_main">
            <component-list
                :component-table="LmsUserAccountActivityLogTable"
                :component-table-name="'activity-log'"
                :filter-search-queryable="true"
                :get-pagination-getter="'getLmsUserAccountActivityLogPagination'"
                :get-items-getter="'getLmsUserAccountActivityLog'"
                :get-items-dispatch="'lmsUserAccountActivityLogGet'"
                :item-name="['record', 'records']"
                :table-preferences-active="true"
            />
        </div>
    </div>
</template>
<script>
import LmsUserAccountActivityLogTable from '@/components/lms/user/account/LmsUserAccountActivityLogTable'
import ComponentList from '@/components/default/shared/ComponentList'

export default {
  name: 'lms-user-account-activity-log',
  components: { ComponentList },
  data () {
    return {
      LmsUserAccountActivityLogTable
    }
  }
}
</script>
<style lang="scss">
    @import "~@/assets/scss/components/lms/user/account/_lmsuseraccountactivitylog.scss";
</style>
